export default __webpack_public_path__ + "static/mapboxStyle-7d3838df6bfb84550ff2b546ccd9265e.png";